import { Component, Input } from '@angular/core';
import { AnalyticsEventType } from '../../../google-analytics/analytics-event-type';
import { GoogleSearchWizard } from '../google-search-wizard/google-search-wizard';
import { MtnMap } from '../../mtn-map';
import { WizardRunnerService } from '../../../core/wizard/wizard-runner.service';

@Component({
  standalone: false,
  selector: 'mtn-google-search-assembly',
  templateUrl: './google-search-assembly.component.html',
  styleUrls: ['./google-search-assembly.component.scss']
})
export class GoogleSearchAssemblyComponent  {

  @Input()
  map: MtnMap;

  AnalyticsEventType = AnalyticsEventType;

  constructor(private wizardRunner: WizardRunnerService) {
  }


  openGoogleSearchWizard(): void {
    const wizard = new GoogleSearchWizard();
    wizard.model = {
      map: this.map
    };

    this.wizardRunner.run(wizard);
  }

}
